import { render, staticRenderFns } from "./zhiboclasssixth.vue?vue&type=template&id=44aac47a&scoped=true"
import script from "./zhiboclasssixth.vue?vue&type=script&lang=js"
export * from "./zhiboclasssixth.vue?vue&type=script&lang=js"
import style0 from "./zhiboclasssixth.vue?vue&type=style&index=0&id=44aac47a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aac47a",
  null
  
)

export default component.exports